export default __webpack_public_path__ + "8ec11c232e52cb5882afc216463b7f91.webp";